module.exports = __webpack_public_path__ + "static/media/esquela_canimolt_JIFC_web.b84ff98e.jpg";